var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subset d-flex justify-content-start no-select",class:{ highlight: _vm.highlight, 'no-hover': _vm.noHover },style:(_vm.style),on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.subset.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }